import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  Button,
  Typography,
  AppBar,
  Toolbar,
  Hidden,
} from "@material-ui/core";
import { Link } from "react-router-dom";

export default function UpdatePhoneBanner() {
  const useStyles = makeStyles((theme) => ({
    background: {
      paddingTop: 0,
      flexGrow: 1,
      backgroundColor: theme.palette.secondary.light,
      textAlign: "left",
    },
    bannerToolbar: {
      paddingTop: 0,
    },
    bannerButton: {
      backgroundColor: theme.palette.background.upgrade,
      border: "2px solid #3aa9de",
      color: theme.palette.common.white,
      "&:hover": {
        border: "2px solid #3cb5ef",
        backgroundColor: theme.palette.background.upgradeHover,
      },
    },
    bannerText: {
      flexGrow: 1,
      color: theme.palette.common.white,
      padding: theme.spacing(1),
      "@media (max-width:600px)": {
        marginBottom: theme.spacing(1),
      },
    },
    mobileBackground: {
      flexGrow: 1,
      backgroundColor: theme.palette.secondary.light,
      textAlign: "left",
      minHeight: "48px",
      padding: "10px 0",
    },
  }));

  const classes = useStyles();

  return (
    <div>
      {/* Visible SM, MD, L, XL */}
      <Hidden xsDown>
        <AppBar position="static" className={classes.background}>
          <Toolbar className={classes.bannerToolbar}>
            <Typography variant="body1" className={classes.bannerText}>
              Secure your account by adding your phone number for login
            </Typography>
            <Link to="/myaccount/add-phone" style={{ textDecoration: "none" }}>
              <Button size="small" className={classes.bannerButton}>
                Add Phone Number
              </Button>
            </Link>
          </Toolbar>
        </AppBar>
      </Hidden>

      {/* Visible XS only */}
      <Hidden smUp>
        <Container className={classes.mobileBackground}>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{
              textAlign: "center",
            }}
          >
            <Grid item xs={12} sm={12}>
              <Typography variant="body2" className={classes.bannerText}>
                Secure your account by adding your phone number for login
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Link
                to="/myaccount/add-phone"
                style={{ textDecoration: "none" }}
              >
                <Button size="small" className={classes.bannerButton}>
                  Add Phone Number
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Hidden>
    </div>
  );
}
